import featureCodes from 'constants/featureCodes'

// Transforms the backend feature-toggle response into the internal FeatureAccess slice shape: { featureCode, isEnabled }[]
export const mapFeatureToggleResponseToFeatureList = toggles => {
  if (!Array.isArray(toggles)) return []

  const validFeatureCodes = new Set(Object.values(featureCodes))

  return toggles
    .filter(
      toggle =>
        toggle &&
        toggle.featureCode &&
        validFeatureCodes.has(toggle.featureCode)
    )
    .map(({ featureCode, enabled }) => ({ featureCode, isEnabled: enabled }))
}
